module.exports = __webpack_public_path__ + "static/media/lol-gold.00af8b10.png";